import React from "react";
import classNames from 'classnames';

import "./Numpad.css";

const NUMS_7 = [1, 2, 3, 4, 5, 6, 0];
const NUMS_10 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];

const Numpad = ({
  disabled,
  isSubmitMode,
  canSubmit,
  hide789,
  labels,
  highlightWrongIndex,
  highlightCorrectIndex,
  highlightStagedIndex,
  onButtonPress,
  onDeletePress,
  onSubmitPress
}) => {
  
  const onButtonPressFn = (value) => (evt) => {
    if (!disabled) {
      onButtonPress(value);
    }
  };

  const buttons = hide789
    ? NUMS_7
    : NUMS_10;

  if (canSubmit && typeof highlightCorrectIndex === 'number') {
    highlightStagedIndex = highlightCorrectIndex;
    highlightCorrectIndex = 'submit';
  }
  if (canSubmit && typeof highlightWrongIndex === 'number') {
    highlightStagedIndex = highlightWrongIndex;
    highlightWrongIndex = 'submit';
  }

  return (
    <div className="Numpad">
      <div className={classNames("-buttons", {
        '--words': labels,
        '--hasSubmit': isSubmitMode,
        '--canSubmit' : canSubmit,
      })}>
        {buttons.map((n, index) => (
          <button
            key={n}
            type="button"
            className={
              "-button --" +
              n +
              (highlightCorrectIndex === n
                ? " --correct"
                : highlightWrongIndex === n
                ? " --wrong"
                : highlightStagedIndex === n
                ? " --staged" : "")
            }
            onClick={onButtonPressFn(n)}
            disabled={disabled}
          >
            <span>{labels ? labels[n] : n}</span>
          </button>
        ))}
        {
          isSubmitMode &&
          <button type="button" className="-button --delete"
            disabled={disabled || !canSubmit}
            onClick={onDeletePress}>
            <span>⌫</span>
          </button>
        }
        {
          isSubmitMode &&
          <button type="button"
            disabled={disabled || !canSubmit}
            onClick={onSubmitPress}
            className={
              "-button --submit" +
              (highlightCorrectIndex === 'submit'
                ? " --correct"
                : highlightWrongIndex === 'submit'
                ? " --wrong"
                : '')
            }>
            <span>{highlightWrongIndex === 'submit' ? '✘': '✓'}</span>
          </button>
        }
      </div>
    </div>
  );
}

export default Numpad;
